import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, NoopAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbAccordionModule, NgbDropdownModule, NgbModule, NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { InterceptorService } from './services/intercepter.service';
import { HeaderComponent } from './shared/header/header.component';
import { LayoutContainerComponent } from './core/layout-container/layout-container.component';
import { AuditLogComponent } from './shared/audit-log/audit-log.component';
import { MaterialModule } from './material.module';
import { FlexLayoutModule, FlexModule } from '@angular/flex-layout';
import { ConfirmationAlertComponent } from './shared/confirmation-alert/confirmation-alert.component';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ToastrModule } from 'ngx-toastr';
import { NgxUiLoaderModule, NgxUiLoaderConfig, SPINNER, POSITION, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule } from 'ngx-ui-loader';
import { DataTableModule } from './shared/data-table/data-table.module';
import { DatePipe } from '@angular/common';
import { ClickOutsideModule } from 'ng-click-outside';
import { SimplebarAngularModule } from 'simplebar-angular';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { ErrorNotificationService } from './services/error-notification.service';
import { environment } from "../environments/environment.prod";
import { initializeApp } from "firebase/app";
initializeApp(environment.firebase);

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsColor: 'rgba(12,80,219,0.98)',
  bgsOpacity: 1,
  bgsPosition: POSITION.bottomRight,
  bgsSize: 60,
  bgsType: SPINNER.threeStrings,
  fgsColor: 'rgba(12,80,219,0.98)',
  fgsPosition: POSITION.centerCenter
};

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    LayoutContainerComponent,
    AuditLogComponent,
    ConfirmationAlertComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    FlexModule,
    FlexLayoutModule,
    NgbModule,
    NgbAccordionModule,
    NgbNavModule,
    NgbTooltipModule,
    NgbDropdownModule,
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule,
    NgxUiLoaderHttpModule,
    SlickCarouselModule,
    DataTableModule,
    ClickOutsideModule,
    SimplebarAngularModule,
    ScrollToModule.forRoot(),
    ToastrModule.forRoot()
  ],
  providers: [
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: ErrorNotificationService },
  ],
  bootstrap: [AppComponent],
  entryComponents: [ConfirmationAlertComponent]
})
export class AppModule { }
